import { useEffect, useRef, useState } from "react";
import { getAPI } from "../API/ApiService";
import { BASE_URL } from "../constant/apiUrl";
import { useDispatch } from "react-redux";
import { setApp, setMobileLoading } from "../slices/appadminSlice";
import fetchAndCacheImage from "../utils/fetchandCatchImages";

export default function useFetchApp() {
  const [data, setData] = useState([]);
  const [mobileData, setMobileData] = useState([]);
  const [loading, setLoading] = useState(true);
  const hasFetched = useRef(false);
  const dispatch = useDispatch();
  useEffect(() => {
    const fetchTableData = async () => {
      try {
        const response = await getAPI(`${BASE_URL}/admin/apps/find-all`);
        if (response?.status === 200) {
          const finalResponse = response?.data?.response;
          const newResponse = finalResponse?.sort((a, b) => a.order - b.order);
          const finalApp = newResponse?.map((app) => ({
            ...app,
            image: app.cdnUrl,
          }));
          setMobileData(finalResponse);

          setData(finalApp);
          dispatch(setApp(finalApp));
          dispatch(setMobileLoading(false));
        }
      } catch (e) {
        console.log(e, "---Error----");
      } finally {
        setLoading(false);
      }
    };
    if (!hasFetched.current) {
      hasFetched.current = true;
      fetchTableData();
    }
  }, []);
  return { data, loading, setData, mobileData, setMobileData };
}
